module.exports = __webpack_public_path__ + "static/media/question_mark.82aced92.png";